import Image from "next/image";
import React from "react";
import { HowItWorks } from "@/assets/images";
import { features } from "@/features/LandingPage/WhyFundview/data";

function Index() {
  return (
    <section id="whyFundview">
      <div className="relative bg-blue-600">
        <div className="absolute left-0 top-0 size-full">
          <Image
            src="https://landingfoliocom.imgix.net/store/collection/saasui/images/how-it-works/3/ring-pattern.svg"
            alt=""
            fill
            className="object-cover opacity-20 2xl:opacity-100"
          />
        </div>

        <div className="relative h-56 bg-gray-900 sm:h-72 md:absolute md:right-0 md:h-full md:w-1/2">
          <Image
            src={HowItWorks}
            alt=""
            fill
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
            className="object-cover"
          />
        </div>

        <div className="relative mx-auto max-w-7xl px-4 py-12 sm:px-6 sm:py-16 lg:px-8 lg:py-20 xl:py-24">
          <div className="md:mr-auto md:w-1/2 md:pr-10">
            <h2 className="text-3xl font-semibold tracking-tight text-white sm:text-4xl lg:text-5xl">Why Fundview?</h2>
            <p className="mt-4 text-base font-normal leading-7 text-blue-300 lg:mt-6 lg:text-lg lg:leading-8">
              A Technology Assistant That Understands the Nuances of CRE Finance Dealflow.
            </p>
          </div>
        </div>
      </div>

      <div className="bg-white py-12 sm:py-16 lg:py-20 xl:py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 gap-12 text-center sm:grid-cols-2 md:grid-cols-3 lg:gap-y-16">
            {features.map(feature => {
              const Icon = feature.icon;
              return (
                <div key={feature.title}>
                  <div className="relative mx-auto flex items-center justify-center">
                    <Icon className="h-20 w-auto" />
                  </div>
                  <h3 className="mt-8 text-lg font-semibold text-black">{feature.title}</h3>
                  <p className="mt-4 text-base text-gray-600">{feature.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Index;
